import React from 'react'
import { Adsense } from '@ctrl/react-adsense'

const AD_SLOTS = {
  display: process.env.REACT_APP_GOOGLE_ADSENSE_SLOT,
  inArticle: process.env.REACT_APP_GOOGLE_ADSENSE_SLOT_IN_ARTICLE,
  inFeed: process.env.REACT_APP_GOOGLE_ADSENSE_SLOT_IN_FEED
}

export const ReactAdSense = ({ adUnit = 'display', adClass }) => {
  const commonProps = {
    className: adClass,
    client: process.env.REACT_APP_GOOGLE_ADSENSE_CLIENT,
    slot: AD_SLOTS[adUnit] || process.env.REACT_APP_GOOGLE_ADSENSE_SLOT
  }

  switch (adUnit) {
    case 'inArticle':
      return (
        <Adsense
          {...commonProps}
          style={{ display: 'block', textAlign: 'center' }}
          format='fluid'
          layout='inArticle'
        />
      )

    case 'inFeed':
      return (
        <Adsense
          {...commonProps}
          style={{ display: 'block' }}
          format='fluid'
          layoutKey='-fb+5w+4e-db+86'
        />
      )

    case 'display':
    default:
      return (
        <Adsense
          {...commonProps}
          style={{ display: 'block' }}
          format='auto'
          responsive='true'
        />
      )
  }
}
